module.exports = __webpack_public_path__ + "static/media/cm_about_banner_02.e341dde6.jpg";